import { HireCardStyles } from '@stories/Components/Cards/HireCard/HireCard.styles';
import styled from 'styled-components';
const Wrapper = styled.div ``;
const List = styled.div `
  max-width: 700px;
  margin: 0 auto;

  ${HireCardStyles.Card} {
    margin-bottom: 24px;
  }
`;
const ButtonWrapper = styled.div `
  text-align: center;
  margin: 50px 0;
`;
export const OrderOverviewStyles = {
    Wrapper,
    List,
    ButtonWrapper,
};
